/**
 * Permission identifiers — must mirror the backend `Permission` enum
 * (`apps/backend/src/libs/auth/roles-permissions.ts`).
 */
export const PERMISSIONS = {
  DASHBOARD_VIEW: 'DASHBOARD_VIEW',
  DASHBOARD_VIEW_ALL: 'DASHBOARD_VIEW_ALL',
  CHANGELOG_VIEW: 'CHANGELOG_VIEW',
  ITEMS_VIEW: 'ITEMS_VIEW',
  ITEMS_EDIT: 'ITEMS_EDIT',
  ITEMS_EDIT_PRICES: 'ITEMS_EDIT_PRICES',
  BUSINESS_PARTNERS_VIEW: 'BUSINESS_PARTNERS_VIEW',
  PREIS_TOOL_VIEW: 'PREIS_TOOL_VIEW',
  PREIS_TOOL_MANAGE: 'PREIS_TOOL_MANAGE',
  SUPPLIER_PRICE_LISTS_VIEW: 'SUPPLIER_PRICE_LISTS_VIEW',
  SUPPLIER_PRICE_LISTS_MANAGE: 'SUPPLIER_PRICE_LISTS_MANAGE',
  ADMIN_VIEW: 'ADMIN_VIEW',
  SYNC_TRIGGER: 'SYNC_TRIGGER',
  USERS_MANAGE: 'USERS_MANAGE',
  ROLES_MANAGE: 'ROLES_MANAGE',
  EMAIL_BUILDER_VIEW: 'EMAIL_BUILDER_VIEW',
  EMAIL_BUILDER_SEND: 'EMAIL_BUILDER_SEND',
  EMAIL_SUBSCRIPTIONS_MANAGE: 'EMAIL_SUBSCRIPTIONS_MANAGE',
  SOURCING_VIEW: 'SOURCING_VIEW',
  SOURCING_MANAGE: 'SOURCING_MANAGE',
  AI_ASSISTANT_VIEW: 'AI_ASSISTANT_VIEW',
  SPECIFICATIONS_VIEW: 'SPECIFICATIONS_VIEW',
  SPECIFICATIONS_MANAGE: 'SPECIFICATIONS_MANAGE',
  ANNOUNCEMENTS_MANAGE: 'ANNOUNCEMENTS_MANAGE',
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
